module.exports = __webpack_public_path__ + "img/img-27.961b9fdd.png";